// extracted by mini-css-extract-plugin
export default {"role-form-section":"RoleForm_role-form-section__CzlcU"};